import { useId } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function FilterSelect(props) {
  const labelId = useId();
  const selectedValue = props.value?.value ?? props.value ?? '';

  const handleChange = (event) => {
    const selected = props.options?.find((option) => option.value === event.target.value);

    props.onChange(
      selected ?? {
        value: event.target.value,
        label: event.target.value
      }
    );
  };

  return (
    <div>
      <FormControl sx={{ m: 0, minWidth: 120 }} style={props.style}>
        <InputLabel id={labelId}>{props.label}</InputLabel>
        <Select
          labelId={labelId}
          label={props.label}
          value={selectedValue}
          onChange={handleChange}
          MenuProps={{ disablePortal: props.disablePortal ?? true, variant: 'menu', ...props.MenuProps }}
          key="FilterSelect-table"
          // SelectDisplayProps={{ style: { paddingTop: 5, paddingBottom: 5 } }}

          // IconComponent={SettingsIcon}
        >
          {props.options?.map((item, index) => (
            <MenuItem value={item?.value} autoFocus divider selected key={'FilterSelect-table-' + index} id={'FilterSelect-table-' + index}>
              {item?.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
